import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
import { trackInitiateCheckout } from '../utils/metaPixel';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-line bg-navy-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-60" data-mp="15bsodlj70gm7">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-61" data-mp="1jbagoavp6c0b">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-62" data-mp="1eettpk08i3ot">
          <span className="inline-flex items-center gap-2" data-id="element-63" data-mp="1t1wqfogqg8b3">
            <ZapIcon className="h-8 w-8 shrink-0 text-fiber" aria-hidden="true" data-id="element-64" data-mp="1o3vahcelsp3u" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-semibold text-gold sm:text-2xl" data-id="element-65" data-mp="22338w32xzt6z">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-silver" data-id="element-66" data-mp="1x64j1wqba8el">
          Created for fiber optic, cabling, radio and telecommunications network professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-8 w-full sm:w-auto" data-id="element-67" data-mp="s57ez4c79qrs">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-silver" data-id="element-68" data-mp="1246dhu394612">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-69" data-mp="1b3js1168fksn">
              <CheckIcon className="h-4 w-4 text-fiber" aria-hidden="true" data-id="element-70" data-mp="1b1qldlvmd0kn" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}